import { Component } from '@verndale/core';
import React from 'react';
import { render } from 'react-dom';
import axios from 'axios';
import ProductSampleSelection from './ProductSampleSelection';
import ProductGuideOverlay from './ProductGuideOverlay';

const reactModule = (Component, nodeList, data) => {
  nodeList.forEach((node) => render(<Component {...node.dataset} data={data} />, node));
};

class ProductSample extends Component {
  constructor(el) {
    super(el);
    this.loadData();
  }

  setupDefaults() {
    this.dom = {
      sampleSelector: this.el.querySelector(
        '.product-detail__sample-selection'
      ),
      productOverlayButton: this.el.querySelector('.product-detail__footer-button-container')
    };
  }

  async loadData() {
    try {
      const { data } = await axios.get(this.el.dataset.endpoint);
      this.initModules(data);

    } catch (error) {
      console.log(error);
    }
  }

  initModules(data) {
    if (this.dom.sampleSelector) {
      new ProductSampleSelection(this.dom.sampleSelector, data);
    }
    if (this.dom.productOverlayButton) {
      reactModule(ProductGuideOverlay, [this.dom.productOverlayButton], data);
    }
  }
}

export default ProductSample;
